/* ============================================================
   THE NATURAL WAYS — Product Page JS
   tnw-scripts.js — Oct 2026 AOV update

   What changed in this version:
   - Two card groups ("For me" / "As a gift") driven by one selector
   - Cards carry their own variant id; falls back to base variant × qty
     when bundle variants don't exist yet (see Liquid header)
   - Dollar savings, per-bottle price and the "+ shipping" chip are
     computed from the card's data attributes, never hardcoded
   - URL params: ?gift=1 opens the gift tab, ?sel=1|2|3|g1|g2|g3 preselects
   - "What's inside" inline expander (tnwToggleInside)
   - Add-ons already inside the selected tier hide + uncheck themselves
   - Sticky bar name/price and final CTA follow the selection
   ============================================================ */
(function () {
'use strict';

/* ---- CONFIG — edit these, nothing else needs touching ---- */
var TNW = {
  freeShipThreshold: 40,     // matches your shipping profile
  singleShipping: 5.99,      // ← set to your REAL single-bottle shipping rate (shown on the 1-bottle card)
  defaultMe: '2',            // card preselected on the "For me" tab (1 | 2 | 3)
  defaultGift: 'g2',         // card preselected on the gift tab (g1 | g2 | g3)
  savePillMin: 3             // hide "Save $X" when X is below this
};
window.TNW_CONFIG = TNW;

function money(n) {
  n = parseFloat(n) || 0;
  return '$' + (Math.round(n * 100) / 100).toFixed(2);
}
function closestMatch(el, className) {
  while (el && el !== document) {
    if (el.classList && el.classList.contains(className)) { return el; }
    el = el.parentNode;
  }
  return null;
}
function closestCard(el) { return closestMatch(el, 'tnw-bcard'); }
function getParam(name) {
  var m = new RegExp('[?&]' + name + '=([^&#]*)').exec(window.location.search);
  return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : null;
}

/* ============================================================
   CAROUSEL (unchanged)
   ============================================================ */
var slides = document.querySelectorAll('.tnw-carousel-slide');
var thumbs = document.querySelectorAll('.tnw-thumb');
var prevBtn = document.querySelector('.tnw-prev');
var nextBtn = document.querySelector('.tnw-next');
var carouselWrap = document.querySelector('.tnw-carousel-wrap');
var currentIndex = 0;

function showSlide(index) {
  if (index < 0) { index = slides.length - 1; }
  if (index >= slides.length) { index = 0; }
  currentIndex = index;
  for (var i = 0; i < slides.length; i++) { slides[i].classList.remove('is-active'); }
  for (var j = 0; j < thumbs.length; j++) { thumbs[j].classList.remove('is-active'); }
  if (slides[currentIndex]) { slides[currentIndex].classList.add('is-active'); }
  if (thumbs[currentIndex]) { thumbs[currentIndex].classList.add('is-active'); }
}
if (prevBtn) { prevBtn.addEventListener('click', function () { showSlide(currentIndex - 1); }); }
if (nextBtn) { nextBtn.addEventListener('click', function () { showSlide(currentIndex + 1); }); }
for (var t = 0; t < thumbs.length; t++) {
  (function (idx) { thumbs[idx].addEventListener('click', function () { showSlide(idx); }); })(t);
}
if (carouselWrap) {
  var touchStartX = 0, touchStartY = 0;
  carouselWrap.addEventListener('touchstart', function (e) {
    touchStartX = e.touches[0].clientX; touchStartY = e.touches[0].clientY;
  }, { passive: true });
  carouselWrap.addEventListener('touchend', function (e) {
    var dx = touchStartX - e.changedTouches[0].clientX;
    var dy = touchStartY - e.changedTouches[0].clientY;
    if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
      if (dx > 0) { showSlide(currentIndex + 1); } else { showSlide(currentIndex - 1); }
    }
  });
}
showSlide(0);

/* ============================================================
   BUNDLE SELECTION + FOR ME / GIFT MODE
   One source of truth: the selected .tnw-bcard's data attributes
   ============================================================ */
(function () {
  var cards = Array.prototype.slice.call(document.querySelectorAll('.tnw-bcard'));
  if (!cards.length) { return; }

  var gridMe = document.getElementById('tnwGridMe');
  var gridGift = document.getElementById('tnwGridGift');
  var modeBtns = Array.prototype.slice.call(document.querySelectorAll('.tnw-mode-btn'));
  var qtyInput = document.getElementById('tnwQtyIn');
  var idInput = document.getElementById('tnwVariantIn');
  var form = document.getElementById('tnw-product-form');
  var baseVariant = (form && form.getAttribute('data-base-variant')) || (idInput ? idInput.value : '');
  var priceMainEl = document.getElementById('tnwPriceMain');
  var priceOldEl = document.getElementById('tnwPriceOld');
  var savePillEl = document.getElementById('tnwSavePill');
  var stickyPriceEl = document.getElementById('tnwStickyPrice');
  var stickyNameEl = document.getElementById('tnwStickyName');
  var ctaBtn = document.getElementById('tnwCtaBtn');
  var micro1 = document.getElementById('tnwMicro1');
  var micro2 = document.getElementById('tnwMicro2');

  var currentMode = 'me';
  var lastSelected = { me: null, gift: null };

  function allCards() {
    return Array.prototype.slice.call(document.querySelectorAll('.tnw-bcard'));
  }
  function cardsIn(mode) {
    return allCards().filter(function (c) { return (c.getAttribute('data-mode') || 'me') === mode; });
  }

  function setQty(value) {
    if (qtyInput) {
      qtyInput.value = value;
      qtyInput.setAttribute('value', value);
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
    }
    window.tnwSelectedBundleQty = value;
  }

  /* Fill the static text inside every card from its data attributes,
     so Liquid prices and the savings copy can never disagree */
  function fillCardText() {
    cards.forEach(function (card) {
      var price = parseFloat(card.getAttribute('data-price')) || 0;
      var compare = parseFloat(card.getAttribute('data-compare')) || 0;
      var bottles = parseInt(card.getAttribute('data-bottles') || '1', 10) || 1;
      var save = compare > price ? compare - price : 0;

      var priceEl = card.querySelector('.tnw-bcard-price');
      if (priceEl) {
        var cmp = priceEl.querySelector('[data-compare-text]');
        var cmpHtml = '';
        if (compare > price) {
          cmpHtml = ' <span class="tnw-bcard-compare" data-compare-text>' + money(compare) + '</span>';
        } else if (cmp) {
          cmpHtml = '';
        }
        priceEl.innerHTML = money(price) + cmpHtml;
      }
      var perEl = card.querySelector('.tnw-bcard-perbottle');
      if (perEl) { perEl.textContent = money(price / bottles) + ' / bottle'; }

      var saveEl = card.querySelector('[data-save-text]');
      if (saveEl) {
        saveEl.textContent = save >= TNW.savePillMin ? 'Save $' + Math.round(save) : '';
        /* tidy a trailing " · " if the save text is empty */
        var desc = saveEl.parentNode;
        if (desc && !saveEl.textContent) {
          desc.innerHTML = desc.innerHTML.replace(/\s*·\s*<strong data-save-text="?"?><\/strong>/, '');
        }
      }
      var chip = card.querySelector('[data-ship-chip]');
      if (chip) { chip.textContent = '+ ' + money(TNW.singleShipping) + ' shipping'; }
    });
  }

  function applyAddonVisibility(card) {
    var hide = (card.getAttribute('data-hide-addons') || '').split(',')
      .map(function (s) { return s.trim(); })
      .filter(function (s) { return s.length; });
    var visibleCount = 0;
    Array.prototype.forEach.call(document.querySelectorAll('.tnw-toggle-item'), function (item) {
      var key = item.getAttribute('data-addon') || '';
      var shouldHide = hide.indexOf(key) !== -1;
      item.hidden = shouldHide;
      if (shouldHide) {
        var inp = item.querySelector('.tnw-toggle-input');
        if (inp) { inp.checked = false; }
        item.classList.remove('tnw-toggle-on');
      } else {
        visibleCount += 1;
      }
    });
    /* Hide the whole "Add More Relief" block when the tier already contains every add-on */
    var fbt = document.getElementById('tnwFbt');
    if (fbt) { fbt.hidden = visibleCount === 0; }
  }

  function selectCard(card) {
    if (!card) { return; }
    allCards().forEach(function (c) { c.classList.remove('selected'); });
    card.classList.add('selected');

    var mode = card.getAttribute('data-mode') || 'me';
    lastSelected[mode] = card;

    var price = parseFloat(card.getAttribute('data-price')) || 0;
    var compare = parseFloat(card.getAttribute('data-compare')) || 0;
    var qty = parseInt(card.getAttribute('data-qty') || '1', 10) || 1;
    var vid = card.getAttribute('data-variant-id') || baseVariant;
    var name = card.getAttribute('data-name') || 'Natural Pain Relief Oil';
    var save = compare > price ? compare - price : 0;
    var saveText = save >= TNW.savePillMin ? 'SAVE $' + Math.round(save) : '';

    setQty(qty);
    if (idInput) { idInput.value = vid; }

    window.tnwCurrentCard = card;
    window.tnwCurrentVariantId = vid;
    window.tnwCurrentBundlePrice = price;
    window.tnwCurrentBundleCompare = compare;
    window.tnwCurrentBundleSave = saveText;
    window.tnwCurrentBundleName = name;

    if (priceMainEl) { priceMainEl.textContent = money(price); }
    if (priceOldEl) { priceOldEl.textContent = compare > price ? money(compare) : ''; priceOldEl.style.display = compare > price ? '' : 'none'; }
    if (savePillEl) { savePillEl.textContent = saveText; savePillEl.style.display = saveText ? '' : 'none'; }
    if (stickyPriceEl) { stickyPriceEl.innerHTML = money(price) + (compare > price ? ' <s>' + money(compare) + '</s>' : ''); }
    if (stickyNameEl) { stickyNameEl.textContent = name; }
    if (ctaBtn) { ctaBtn.textContent = 'Shop Now — ' + money(price); }

    applyAddonVisibility(card);
    if (window.tnwUpdateAddonTotal) { window.tnwUpdateAddonTotal(); }
  }

  function defaultCardFor(mode) {
    var key = mode === 'gift' ? TNW.defaultGift : TNW.defaultMe;
    return lastSelected[mode]
      || document.querySelector('.tnw-bcard[data-mode="' + mode + '"][data-key="' + key + '"]')
      || cardsIn(mode)[0]
      || null;
  }

  function setMode(mode) {
    if (mode === 'gift' && (!gridGift || !cardsIn('gift').length)) { mode = 'me'; }
    currentMode = mode;
    modeBtns.forEach(function (btn) {
      var on = btn.getAttribute('data-mode') === mode;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    if (gridMe) { gridMe.hidden = mode !== 'me'; }
    if (gridGift) { gridGift.hidden = mode !== 'gift'; }
    if (micro1) { micro1.textContent = mode === 'gift' ? 'Choose Your Gift' : 'Choose Your Bundle'; }
    if (micro2) { micro2.textContent = mode === 'gift' ? 'Ships gift-ready · add a gift note at checkout' : 'Most customers go through a bottle every 3–4 weeks'; }
    selectCard(defaultCardFor(mode));
  }

  /* Clicks — delegated at the document level, so the cards and the toggle keep
     working even if the theme re-renders the product section */
  document.addEventListener('click', function (e) {
    var modeBtn = closestMatch(e.target, 'tnw-mode-btn');
    if (modeBtn) { setMode(modeBtn.getAttribute('data-mode') || 'me'); return; }
    var card = closestCard(e.target);
    if (card) { selectCard(card); }
  });

  /* Public helpers */
  window.tnwBundle = function (key) {
    var card = document.querySelector('.tnw-bcard[data-key="' + key + '"]') || document.getElementById('tnwB' + key);
    if (!card) { return; }
    var mode = card.getAttribute('data-mode') || 'me';
    lastSelected[mode] = card;
    setMode(mode);
  };
  window.tnwSetMode = setMode;

  /* "What's inside" expander — also selects the card */
  window.tnwToggleInside = function (e, btn) {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    var card = closestCard(btn);
    if (!card) { return; }
    var panel = card.querySelector('.tnw-bcard-inside');
    if (!panel) { return; }
    var open = panel.hidden;              /* currently hidden → we are opening */
    panel.hidden = !open;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.classList.toggle('is-open', open);
    selectCard(card);
  };

  /* ---- Init: text, URL params, default selection ---- */
  fillCardText();

  var startMode = 'me';
  var pGift = getParam('gift');
  var pSel = getParam('sel');
  var pVar = getParam('variant');

  if (pGift === '1' || pGift === 'true' || pGift === 'yes') { startMode = 'gift'; }

  if (pSel) {
    var selCard = document.querySelector('.tnw-bcard[data-key="' + pSel.replace(/[^a-z0-9]/gi, '') + '"]');
    if (selCard) {
      startMode = selCard.getAttribute('data-mode') || 'me';
      lastSelected[startMode] = selCard;
    }
  } else if (pVar) {
    /* A ?variant= link straight to a bundle variant opens that card */
    var varCard = null;
    cards.forEach(function (c) {
      if (!varCard && c.getAttribute('data-variant-id') === pVar && pVar !== baseVariant) { varCard = c; }
    });
    if (varCard) {
      startMode = varCard.getAttribute('data-mode') || 'me';
      lastSelected[startMode] = varCard;
    }
  }

  setMode(startMode);
})();

/* ============================================================
   ADD TO CART — combined AJAX add (selected tier + toggled add-ons)
   ============================================================ */
window.tnwSubmit = function () {
  var idInput = document.getElementById('tnwVariantIn') || document.querySelector('#tnw-product-form input[name="id"]');
  var qtyInput = document.getElementById('tnwQtyIn');
  var btn = document.getElementById('tnwAtcBtn');

  /* SOURCE OF TRUTH = the card that is visibly selected right now.
     The hidden inputs are only a fallback, so nothing else on the page
     (theme scripts, apps, a re-rendered section) can send a stale variant. */
  var selected = document.querySelector('.tnw-bcard.selected');
  var variantId = (selected && selected.getAttribute('data-variant-id')) || (idInput ? idInput.value : '');
  var qty = parseInt((selected && selected.getAttribute('data-qty')) || (qtyInput ? qtyInput.value : '1'), 10) || 1;
  if (!variantId) { showToast('Please choose an option first'); return; }

  /* keep the form inputs in sync for anything that reads them */
  if (idInput) { idInput.value = variantId; }
  if (qtyInput) { qtyInput.value = qty; }

  var items = [
    { id: variantId, quantity: qty }
  ];

  /* Visible + toggled-ON add-ons ride along in the same request */
  Array.prototype.forEach.call(document.querySelectorAll('.tnw-toggle-item'), function (item) {
    if (item.hidden) { return; }
    var toggle = item.querySelector('.tnw-toggle-input');
    if (toggle && toggle.checked) {
      var vid = item.getAttribute('data-variant-id');
      if (vid) { items.push({ id: vid, quantity: 1 }); }
    }
  });

  var originalText = btn ? btn.textContent : '';
  if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }

  /* Visible in the browser console — tells you exactly which variant was sent */
  if (window.console && console.log) {
    console.log('[TNW] add to cart →', selected ? (selected.getAttribute('data-name') + ' (' + selected.getAttribute('data-key') + ')') : 'no card', items);
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: items })
  })
  .then(function (res) {
    if (!res.ok) { throw new Error('Add to cart failed'); }
    return res.json();
  })
  .then(function () {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    /* Send the customer to cart to see everything that was just added.
       If your theme has a cart drawer you'd rather open instead,
       swap this line for your theme's drawer-open call. */
    window.location.href = '/cart';
  })
  .catch(function (err) {
    console.error(err);
    if (btn) { btn.textContent = originalText || 'Try Again'; btn.disabled = false; }
    showToast('Couldn’t add to cart — please try again');
  });
};

/* ============================================================
   TOAST HELPER
   ============================================================ */
var toastTimer = null;
function showToast(message) {
  var toast = document.getElementById('tnwToast');
  if (!toast) { return; }
  toast.textContent = message;
  toast.classList.add('show');
  if (toastTimer) { clearTimeout(toastTimer); }
  toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 2200);
}

/* ============================================================
   LIVE TOTAL — button label + shipping note
   ============================================================ */
window.tnwUpdateAddonTotal = function () {
  var btn = document.getElementById('tnwAtcBtn');
  if (!btn) { return; }

  var total = window.tnwCurrentBundlePrice || 0;
  var count = 1;

  Array.prototype.forEach.call(document.querySelectorAll('.tnw-toggle-item'), function (item) {
    var toggle = item.querySelector('.tnw-toggle-input');
    if (!item.hidden && toggle && toggle.checked) {
      total += parseFloat(item.getAttribute('data-price')) || 0;
      count += 1;
      item.classList.add('tnw-toggle-on');
    } else {
      item.classList.remove('tnw-toggle-on');
    }
  });

  btn.textContent = count > 1
    ? 'Add to Cart — ' + money(total) + ' (' + count + ' items)'
    : 'Add to Cart — ' + money(total);

  /* Shipping note — tier-aware */
  var shipEl = document.getElementById('tnwShipNote');
  if (shipEl) {
    var card = window.tnwCurrentCard || document.querySelector('.tnw-bcard.selected');
    var free = card && card.getAttribute('data-free-ship') === '1';
    var extra = card ? (card.getAttribute('data-ship-extra') || '') : '';
    var key = card ? (card.getAttribute('data-key') || '') : '';
    var message;

    if (free || total >= TNW.freeShipThreshold) {
      message = '✓ Free shipping included';
    } else if (key === '1') {
      message = '+ ' + money(TNW.singleShipping) + ' shipping · add 1 more bottle for FREE shipping';
    } else {
      message = 'Add ' + money(TNW.freeShipThreshold - total) + ' more to unlock FREE shipping';
    }
    if (extra) { message += ' · ' + extra; }
    shipEl.textContent = message;
  }
};

/* ============================================================
   ALL REVIEWS — "See More" expand toggle (unchanged)
   ============================================================ */
window.tnwToggleReviews = function () {
  var extraItems = document.querySelectorAll('.tnw-allrev-extra');
  var btn = document.getElementById('tnwAllRevMoreBtn');
  if (!extraItems.length || !btn) { return; }
  var isExpanded = btn.getAttribute('data-expanded') === 'true';
  Array.prototype.forEach.call(extraItems, function (item) {
    item.classList.toggle('tnw-allrev-hidden', isExpanded);
  });
  btn.setAttribute('data-expanded', isExpanded ? 'false' : 'true');
  btn.textContent = isExpanded ? 'See 27 More Reviews' : 'Show Less';
};

/* ============================================================
   FAQ ACCORDION (unchanged)
   ============================================================ */
var faqItems = document.querySelectorAll('.tnw-faq-item');
for (var f = 0; f < faqItems.length; f++) {
  (function (item) {
    var btn = item.querySelector('.tnw-faq-q');
    if (!btn) { return; }
    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('open');
      for (var k = 0; k < faqItems.length; k++) {
        faqItems[k].classList.remove('open');
        var b = faqItems[k].querySelector('.tnw-faq-q');
        if (b) { b.setAttribute('aria-expanded', 'false'); }
      }
      if (!isOpen) { item.classList.add('open'); btn.setAttribute('aria-expanded', 'true'); }
    });
  })(faqItems[f]);
}

/* ============================================================
   STICKY ATC — hide while hero is in view (mobile only)
   ============================================================ */
var stickyBar = document.getElementById('tnwSticky');
var heroSec = document.getElementById('tnwHero');
if (stickyBar && heroSec && window.IntersectionObserver) {
  var stickyObs = new IntersectionObserver(function (entries) {
    for (var e = 0; e < entries.length; e++) {
      if (window.innerWidth < 768) {
        stickyBar.style.display = entries[e].isIntersecting ? 'none' : 'flex';
      }
    }
  }, { threshold: 0.05 });
  stickyObs.observe(heroSec);
}

/* ============================================================
   SCROLL FADE-IN
   ============================================================ */
if (window.IntersectionObserver) {
  var fadeEls = document.querySelectorAll(
    '.tnw-why-card, .tnw-ingr-card, .tnw-rev-card, .tnw-bcard, .tnw-how-step, .tnw-toggle-item, .tnw-allrev-item'
  );
  var fadeObs = new IntersectionObserver(function (entries) {
    for (var e = 0; e < entries.length; e++) {
      if (entries[e].isIntersecting) {
        entries[e].target.style.opacity = '1';
        entries[e].target.style.transform = 'translateY(0)';
        fadeObs.unobserve(entries[e].target);
      }
    }
  }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });
  for (var el = 0; el < fadeEls.length; el++) {
    fadeEls[el].style.opacity = '0';
    fadeEls[el].style.transform = 'translateY(16px)';
    fadeEls[el].style.transition = 'opacity 0.48s ease, transform 0.48s ease';
    fadeObs.observe(fadeEls[el]);
  }
}

/* ============================================================
   PREVENT HORIZONTAL OVERFLOW
   ============================================================ */
document.documentElement.style.overflowX = 'hidden';

/* ============================================================
   REVIEW SLIDER — one card per swipe, clamped drag (unchanged)
   ============================================================ */
(function () {
  var slider = document.querySelector('.tnw-rev-scroll');
  if (!slider) { return; }
  var startX = 0, startY = 0, startScroll = 0;
  var isLocked = false, isDragging = false, cardWidth = 0;

  function getCardWidth() {
    var card = slider.querySelector('.tnw-rev-card');
    return card ? card.offsetWidth + 12 : 0;
  }
  function snapToIndex(index) {
    var total = slider.querySelectorAll('.tnw-rev-card').length;
    index = Math.max(0, Math.min(index, total - 1));
    slider.scrollTo({ left: index * cardWidth, behavior: 'smooth' });
  }
  slider.addEventListener('touchstart', function (e) {
    cardWidth = getCardWidth();
    startX = e.touches[0].clientX; startY = e.touches[0].clientY;
    startScroll = slider.scrollLeft; isLocked = false; isDragging = true;
  }, { passive: true });
  slider.addEventListener('touchmove', function (e) {
    if (!isDragging) { return; }
    var dx = e.touches[0].clientX - startX;
    var dy = e.touches[0].clientY - startY;
    if (!isLocked && Math.abs(dy) > Math.abs(dx)) { isDragging = false; return; }
    isLocked = true;
    e.preventDefault();
    var maxDrag = cardWidth * 0.9;
    var clamped = Math.max(-maxDrag, Math.min(maxDrag, -dx));
    slider.scrollLeft = startScroll + clamped;
  }, { passive: false });
  slider.addEventListener('touchend', function (e) {
    if (!isDragging || !isLocked) { isDragging = false; return; }
    isDragging = false;
    var dx = startX - e.changedTouches[0].clientX;
    if (Math.abs(dx) < 10) { snapToIndex(Math.round(startScroll / cardWidth)); return; }
    var currentIdx = Math.round(startScroll / cardWidth);
    snapToIndex(dx > 0 ? currentIdx + 1 : currentIdx - 1);
  }, { passive: true });
})();

/* ============================================================
   INITIAL SYNC
   ============================================================ */
if (window.tnwUpdateAddonTotal) { window.tnwUpdateAddonTotal(); }

})();
